import React, { useState } from 'react';

function CasinoCard({ casino, rank }) {
  const [imgError, setImgError] = useState(false);

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;
    
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<span key={i} className="star filled">★</span>);
      } else if (i === fullStars && hasHalf) {
        stars.push(<span key={i} className="star half">★</span>);
      } else {
        stars.push(<span key={i} className="star">★</span>);
      }
    }
    return stars;
  };

  return (
    <div className={`casino-card ${casino.featured ? 'featured' : ''}`}>
      {casino.featured && <div className="featured-badge">★ Top Pick</div>}
      {rank && <div className="rank-badge">#{rank}</div>}
      
      <div className="casino-card-header">
        <div className="casino-logo">
          {!imgError ? (
            <img 
              src={casino.logo} 
              alt={`${casino.name} logo`}
              onError={() => setImgError(true)}
            />
          ) : (
            <div className="logo-fallback">
              {casino.name.charAt(0)}
            </div>
          )}
        </div>
        <div className="casino-info">
          <h3 className="casino-name">{casino.name}</h3>
          <div className="casino-rating">
            <div className="stars">{renderStars(casino.rating)}</div>
            <span className="rating-value">{casino.rating}/5</span>
          </div>
        </div>
      </div>

      <div className="casino-bonus">
        <span className="bonus-label">Welcome Bonus</span>
        <span className="bonus-value">{casino.bonus}</span>
      </div>

      <p className="casino-description">{casino.description}</p>

      <div className="casino-badges">
        {casino.badges.slice(0, 4).map((badge, index) => (
          <span key={index} className="badge">{badge}</span>
        ))}
      </div>

      <div className="casino-actions">
        <a 
          href={casino.url} 
          target="_blank" 
          rel="noopener noreferrer sponsored"
          className="btn btn-primary"
        >
          Visit Casino
        </a>
        <a href="#" className="btn btn-secondary">Read Review</a>
      </div>

      <div className="casino-footer">
        <span className="tc-apply">18+ | T&Cs Apply | Play Responsibly</span>
      </div>
    </div>
  );
}

export default CasinoCard;
